<template>
  <div class="recharge-wrap">

    <el-form class="recharge-card" ref="form" autoComplete="on" :model="form" v-loading="loading"
      element-loading-text="给我一点时间" label-position="right" label-width="120px" label-suffix="：">
      <div class="my-card-title">还款</div>

      <div class="recharge-info-form my-form">
        <div class="form-item">
          <label>还款明细</label>
          <div>
            <el-table :data="orderList" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
              fit highlight-current-row>
              <el-table-column label="订单编号" align="center" width="160" prop="order_no">
              </el-table-column>
              <el-table-column label="商品名称" align="center" minWidth="150" prop="product_name">
              </el-table-column>
              <el-table-column label="还款金额" align="center" width="100">
                <template slot-scope="{row}">
                  <span>￥{{ row.credit_deposit_amount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="下单时间" align="center" width="180">
                <template slot-scope="{row}">
                  <span>{{ row.create_time }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-item">
          <label>还款方式</label>
          <div>
            <div class="pay-type-wrap">
              <div :class="[{ 'active': method == 0 }, 'item']" @click="method = 0">对公转账</div>
              <div :class="[{ 'active': method == 1 }, 'item']" @click="method = 1">扫码支付</div>
            </div>
          </div>
        </div>
        <template v-if="method == 0">
          <div class="form-item">
            <label>账号信息</label>
            <div>
              <div class="remittance-info">
                <div class="list">
                  <div>开户名称：</div>
                  <div>{{ config.account_name }}</div>
                  <div>开户银行：</div>
                  <div>{{ config.bank_name }}</div>
                  <div>专属汇款账号：</div>
                  <div>{{ config.account_no }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-item">
            <label>还款金额</label>
            <div class="can-drawal-num">
              <p><i>￥{{ form.price }}</i>元</p>
            </div>
          </div>
          <div class="form-item">
            <label>付款凭证</label>
            <div>
              <div class="input-group">
                <form-images v-model="form.voucher" :config="{}"></form-images>
                <div class="tip mgt20 fs13">提示：请上传gif,jpg,png,jpeg,等格式图片，大小不超过4M</div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="method == 1">
          <div class="form-item">
            <label>还款金额</label>
            <div class="can-drawal-num">
              <p><i>￥{{ form.price }}</i>元</p>
            </div>
          </div>

          <div class="form-item align-top">
            <label>支付方式</label>
            <div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="pay-type" id="pay-type1" value="0"
                  v-model="form.payment_type">
                <label class="form-check-label custom-label" for="pay-type1">
                  <img src="~@/assets/images/wx_pay.png" alt="">微信支付
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="pay-type" id="pay-type2" value="1"
                  v-model="form.payment_type">
                <label class="form-check-label custom-label" for="pay-type2">
                  <img src="~@/assets/images/ali_pay.png" alt="">支付宝支付
                </label>
              </div>
            </div>
          </div>
        </template>
        <el-form-item label="">
          <el-button class="my-btn" @click="handleSubmit" :loading="loading">立即还款</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 付款二维码 -->
    <pay-qrcode :pay="pay" :visible.sync="showQrcodeForm" @success="handleSuccess" />
  </div>
</template>

<script>
import { getRepaymentPreview as getUserRepaymentPreview } from "@/api/order";
import { getRepaymentPreview as getTeamRepaymentPreview } from "@/api/team";
import { doPay } from "@/api/pay";
import { getConfig } from "@/api/common";
import PayQrcode from '@/components/payQrcode';
import FormImages from '@/components/form/images' //多图上传
export default {
  name: 'UserRecharge',
  components: {
    PayQrcode,
    FormImages
  },
  data() {
    return {
      loading: false,
      showQrcodeForm: false,
      method: 0,
      emptyText: '暂无数据',
      form: {
        type: 2,
        payment_type: 0,
        price: 0.00,
        voucher: [],
      },
      pay: {},
      type: '',
      order_ids: '',
      orderList: [],
      config: {}
    };
  },
  computed: {

  },
  created() {
    this.type = this.$route.params.type || 'user'
    this.order_ids = this.$route.query.id
    this.getConfig();
    this.getRepaymentPreview();
  },
  methods: {
    getConfig() {
      getConfig({ group: 'account' }).then((res) => {
        this.config = res.data
      }).catch((err) => {
        console.log(err);
      })
    },
    getRepaymentPreview() {
      if (this.type == 'team') {
        getTeamRepaymentPreview({ id: this.order_ids, type: this.type }).then(res => {
          this.loading = false;
          this.orderList = res.data;
          this.form.price = res.data.map(item => {
            return item.credit_deposit_amount
          }).reduce((a, b) => {
            return parseFloat(a) + parseFloat(b)
          })
        }).catch((err) => {

        });
      } else {
        getUserRepaymentPreview({ id: this.order_ids, type: this.type }).then(res => {
          this.loading = false;
          this.orderList = res.data;
          this.form.price = res.data.map(item => {
            return parseFloat(item.credit_deposit_amount)
          }).reduce((a, b) => {
            return parseFloat(a) + parseFloat(b)
          })
        }).catch((err) => {

        });
      }

    },
    // 提交订单
    handleSubmit() {
      const _form = Object.assign({}, this.form);
      if (this.method == 0) {
        if (_form.voucher.length == 0) {
          this.$message.error('请上传付款凭证！');
          return false;
        }
        _form.payment_type = 4;
        _form.voucher = _form.voucher.map(item => {
          return item.url
        })
      }
      _form.order_ids = this.order_ids;
      _form.team = this.type == 'team' ? 1 : 0;
      this.loading = true
      doPay(_form).then((res) => {
        this.loading = false;
        if (res.data.payment_type == 0 || res.data.payment_type == 1) {
          this.pay = res.data
          this.showQrcodeForm = true;
        } else {
          // 弹出操作提示
          this.$message.success(res.msg)
          this.handleSuccess()
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleReset() {
      this.form = {
        type: 2,
        payment_type: 0,
        price: null,
        voucher: [],
      }
      this.$refs.form.resetFields()
    },
    //支付成功
    handleSuccess() {
      this.$refs.form.resetFields()
      this.$router.back()
    }
  }
};
</script>

<style lang="scss" scoped>
.recharge-wrap {
  width: 100%;
  padding: 20px 0 95px 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #F4F8F9;

  .recharge-card {
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.0196);
    display: flex;
    flex-direction: column;

    .recharge-info-form {
      width: 100%;
      padding: 19px 77px;
      box-sizing: border-box;

      .form-item {
        display: grid;
        grid-template-columns: 130px auto;
        column-gap: 10px;
        margin-bottom: 15px;
        align-items: center;

        .form-check {
          display: grid;
          grid-template-columns: 18px auto;
          align-items: center;
          column-gap: 0;
          line-height: initial;
          padding: 9px 0;

          .custom-label {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            color: #333333;

            &>img {
              width: 30px;
              height: 30px;
              margin-left: 20px;
              margin-right: 20px;
            }
          }

          .balance-num {
            font-size: 14px;
            font-weight: 300;
            color: #a0a9ac;
            margin-left: 15px;
          }
        }

        .can-drawal-num {
          font-size: 14px;
          color: #333333;
          display: flex;
          align-items: center;

          i {
            font-size: 14px;
            font-weight: bold;
            color: #fabe2a;
            margin-right: 10px;
          }
        }

        .add-btn {
          width: 100%;
          border-radius: 4px;
          border: 1px solid #b8c4d1;
          font-size: 13px;
          font-weight: 400;
          color: #a0a9ac;
          padding: 10px 0;
          line-height: 15px;
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;

          i {
            font-weight: bold;
            margin-right: 10px;
            font-size: 15px;
          }
        }

        .balance {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-top: 23px;

          &>i {
            font-size: 14px;
            font-weight: 400;
            color: #a0a9ac;
            margin-left: 17px;
          }
        }

        .my-btn {
          // margin: 0 0 0 auto;
        }
      }

      .pay-type-wrap {
        display: flex;
        align-items: center;
        column-gap: 25px;

        .item {
          padding: 12px 35px;
          font-size: 16px;
          font-weight: 400;
          color: #A0A9AC;
          border: 1px solid #A0A9AC;
          cursor: pointer;
        }

        .active {
          border: 1px solid #00B4E8;
          color: #00B4E8;
        }
      }

      .remittance-info {
        width: 100%;
        padding: 16px 0 23px 0;
        background: #F5F9FA;
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
        color: #6F7F84;

        .list {
          display: grid;
          grid-template-columns: 98px auto;
          gap: 13px;
          margin-top: 15px;

          div:nth-child(odd) {
            text-align: right;
          }

          div:last-child {
            color: #00B4E8;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
